import * as React from "react";
import { Button, MenuItem, Tag, Intent } from "@blueprintjs/core";
import { MultiSelect } from "@blueprintjs/select";
import { ITEM_LIST } from "../../utils";

interface Props {
  value: string[];
  onChange: (selected: string[]) => void;
};

export class PermissaoMultiselect extends React.Component<Props> {

  handleItemSelect = (item: string) => {

    const { value, onChange } = this.props;

    if (value.includes(item)) {

      onChange(value.filter(i => i !== item));

    } else {

      onChange([...value, item]);

    }

  };

  handleTagRemove = (_tag: string, index: number) => {

    const newSelection = this.props.value.filter((_, i) => i !== index);

    this.props.onChange(newSelection);

  };

  clearAll = () => {

    this.props.onChange([]);

  };

  renderItem = (item: string, { handleClick, modifiers }: any) => {

    if (!modifiers.matchesPredicate) return null;

    return (
      <MenuItem
        key={item}
        text={item}
        onClick={handleClick}
        active={modifiers.active}
        label={this.props.value.includes(item) ? "✓" : undefined}
      />
    );
  };

  filterItem = (query: string, item: string) => {
    return item.toLowerCase().includes(query.toLowerCase());
  };

  render() {
    const { value } = this.props;

    return (
      <div style={{ width: 600 }}>
        <MultiSelect
          items={ITEM_LIST}
          selectedItems={value}
          itemRenderer={this.renderItem}
          tagRenderer={item => item}
          tagInputProps={{
            onRemove: this.handleTagRemove,
            rightElement: (
              <Button
                icon="cross"
                minimal
                onClick={this.clearAll}
              />
            )
          }}
          onItemSelect={this.handleItemSelect}
          itemPredicate={this.filterItem}
          noResults={<MenuItem disabled={true} text="Sem resultados." />}
          popoverProps={{ minimal: true, fill: true }}
          fill={true}
          className="multiselect-permissao"
          placeholder="Selecione"
        />
      </div>
    );
  }
}
